import { useI18n } from "@/i18n";
import { Globe } from "lucide-react";

export default function LanguageSelector() {
  const { lang, setLang } = useI18n();
  return (
    <div className="flex items-center gap-1 border border-border/60 rounded-sm p-0.5" data-testid="language-selector">
      <Globe className="w-3 h-3 text-zinc-500 ml-1.5" strokeWidth={1.5} />
      {["en", "id"].map((l) => (
        <button
          key={l}
          data-testid={`lang-${l}`}
          onClick={() => setLang(l)}
          className={`px-2 py-0.5 text-[10px] font-mono uppercase tracking-widest rounded-sm transition-colors duration-150 ${
            lang === l ? "bg-emerald-500/20 text-emerald-300" : "text-zinc-500 hover:text-white"
          }`}
        >
          {l === "en" ? "EN" : "ID"}
        </button>
      ))}
    </div>
  );
}
